import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { captureSupabaseError } from '../lib/sentry';

export function useSectionMaxScore(sectionId: string | undefined) {
  const [maxScore, setMaxScore] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [error, setError] = useState<any>(null);

  const fetchMaxScore = useCallback(async () => {
    if (!sectionId) return;

    setLoading(true);
    setError(null);

    try {
      const { data, error } = await supabase.functions.invoke(
        'get-section-max-score?section_id=' + sectionId,
        { method: 'GET' }
      );

      if (error) throw error;

      const parsed = typeof data === 'string' ? JSON.parse(data) : data;

      setMaxScore(typeof parsed?.max_score === 'number' ? parsed.max_score : 0);
    } catch (err) {
      captureSupabaseError(err, { op: 'section.maxScore' });
      console.error('Error fetching max score:', err);
      setError(err);
      setMaxScore(null);
    } finally {
      setLoading(false);
    }
  }, [sectionId]);

  useEffect(() => {
    fetchMaxScore();
  }, [fetchMaxScore]);

  return { maxScore, loading, error, refresh: fetchMaxScore };
}
